import { React } from "react";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { MainPage, ComicsPage, SingleComicPage } from "../pages";

import AppHeader from "../appHeader/AppHeader";
import Spinner from "../spinner/Spinner";
import AppBanner from "../appBanner/AppBanner";

// import Page404 from "../pages/404";

const Page404 = lazy(() => import("../pages/404"));
const MainPage = lazy(() => import("../pages/MainPage"));
const ComicsPage = lazy(() => import("../pages/ComicsPage"));
const SingleComicPage = lazy(() => import("../pages/SingleComicPage"));

const App = () => {
  return (
    <Router>
      <div className="app">
        <AppHeader />
        <main>
          <Suspense fallback={<Spinner />}>
            <Routes>
              {/* <Route path="/" element={<AppHeader />}> */}
              <Route index element={<MainPage />} />
              <Route path="comics" element={<AppBanner />}>
                <Route index element={<ComicsPage />} />
                <Route path=":comicId" element={<SingleComicPage />} />
                <Route path="*" element={<Page404 />} />
              </Route>
              <Route path="*" element={<Page404 />}></Route>
              {/* </Route> */}
            </Routes>
          </Suspense>
        </main>
      </div>
    </Router>
  );
};

export default App;
